export function hasIntersection<T extends unknown[]>(
  arr1?: T,
  arr2?: T,
): boolean {
  if (arr1 === undefined || arr2 === undefined) return false;
  return arr1.filter((value) => arr2.includes(value)).length > 0;
}
